import { SetStateAction, useContext } from "react";

import moment from "moment";

import { TimeZoneContext } from "../../../context/TimeZone/TimeZoneProvider";
import { DATE_FORMATS, useDateTime } from "../../../shared";
import { SCHEDULE_PAYLOAD_NAMES, ScheduleDataDto } from "../types";

interface UseScheduleFormContentProps {
  createSchedule: boolean | undefined;
  scheduleData: ScheduleDataDto | null | undefined;
  inputValues: any;
}

const useScheduleFormContent = ({
  createSchedule,
  scheduleData,
  inputValues
}: UseScheduleFormContentProps) => {
  const { currentTimeZone } = useContext(TimeZoneContext);

  const { formattedDate } = useDateTime();

  const createScheduleStartRawDate =
    createSchedule &&
    (scheduleData?.[SCHEDULE_PAYLOAD_NAMES.StartDate] ??
      inputValues[SCHEDULE_PAYLOAD_NAMES.StartDate]);

  const editScheduleStartRawDate =
    !createSchedule && (scheduleData?.nextDate ?? inputValues?.nextDate);

  const datePickerStartDateValue =
    createSchedule && scheduleData?.[SCHEDULE_PAYLOAD_NAMES.StartDate];

  const datePickerNextDateValue = scheduleData?.nextDate;

  const startDateRaw = createScheduleStartRawDate || editScheduleStartRawDate;

  const findOriginalStartDay = () => {
    const parsed = moment
      .utc(startDateRaw, moment.ISO_8601, true)
      .tz(currentTimeZone);
    return parsed.isValid() ? parsed.date() : 1;
  };

  const updateOriginalStarDate = (
    newDate: string | null,
    setOriginalStartDay: (value: SetStateAction<number>) => void
  ) => {
    const parsed = moment(newDate, moment.ISO_8601, true);
    if (parsed.isValid()) {
      setOriginalStartDay(parsed.date());
    }
  };

  const initialDatePickerValue = scheduleData
    ? formattedDate(
        // show start date in create schedule dialog and next date in edit schedule dialog
        datePickerStartDateValue || datePickerNextDateValue,
        DATE_FORMATS.DateHoursMinutes
      )
    : inputValues[SCHEDULE_PAYLOAD_NAMES.StartDate];

  return {
    startDateRaw,
    datePickerStartDateValue,
    datePickerNextDateValue,
    initialDatePickerValue,
    findOriginalStartDay,
    updateOriginalStarDate
  };
};

export default useScheduleFormContent;
